module.exports = __webpack_public_path__ + "static/media/selfie.c42f1826.jpeg";